export default __webpack_public_path__ + "static/media/logoRiskapp.570ef164.svg";